export enum ActionType {
	Create = "Create",
	View = "View",
	Update = "Update",
	Delete = "Delete",
	Disable = "Disable",
	Enable = "Enable",
}
